import { useState } from 'react'

// Перетаскивание файлов на область загрузки.
// Возвращает флаг подсветки, готовые обработчики для контейнера
// и стиль рамки, чтобы разметка выглядела одинаково во всех разделах.
const useFileDrop = (onFile, { multiple = false } = {}) => {
	const [isDragOver, setIsDragOver] = useState(false)

	const dropProps = {
		onDragOver: (e) => {
			e.preventDefault()
			setIsDragOver(true)
		},
		onDragLeave: () => setIsDragOver(false),
		onDrop: async (e) => {
			e.preventDefault()
			setIsDragOver(false)

			const files = e.dataTransfer?.files
			if (!files || !files.length) return

			await onFile(multiple ? files : files[0])
		},
	}

	const dropStyle = isDragOver
		? { border: '2px dashed #5b73e8', background: 'var(--dark-tint-primary, #eef2ff)' }
		: undefined

	return { isDragOver, dropProps, dropStyle }
}

export default useFileDrop
